import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import UpcomingTrainings from '../upcoming-trainings/upcoming-trainings';
import type { UpcomingTrainingsList as Props } from './upcoming-trainings-list.types';

const UpcomingTrainingsList: React.FunctionComponent<Props> = ({
  title,
  titleProps,
  upcomingTrainings,
}) => (
  <div className="upcoming-trainings-list">
    <Text {...titleProps}>{title}</Text>
    <UpcomingTrainings {...upcomingTrainings} />
  </div>
);

export default UpcomingTrainingsList;
